import { Component, Input, AfterViewInit, OnDestroy, ViewChild, ElementRef,
    ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { NewsService } from '@app/core/services/news.service';
import { Subscription, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { EventListenerService } from '@app/core/services/event-listener.service';

@Component({
    selector: 'ins-news-carousel',
    templateUrl: 'news-carousel.component.html',
    styleUrls: ['news-carousel.component.scss'],
})
export class NewsCarouselComponent implements AfterViewInit, OnDestroy {

    private tabletSize: number = 657;
    private mobileSize: number = 600;

    private resizeTimer$: Observable<Event> = this.eventListenerService.windowEvent<Event>('resize').pipe(
        debounceTime(250)
    );
    private subscriptions: Subscription = new Subscription();
    @Input() itemsInView: number;
    @Input() newsCategory: string = null;

    @ViewChild('newsCarousel', { static: true }) newsCarousel: ElementRef;

    public items: any[] = [];
    public itemWidth = 'auto';

    constructor(
        private newsService: NewsService,
        private cd: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: object,
        private eventListenerService: EventListenerService,
    ) {}

    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.subscriptions.add(
                this.resizeTimer$.subscribe( () => this.calculateWidth() )
            );

            this.getNieuwsLeuks();
            this.calculateWidth();
        }
    }

    public getNieuwsLeuks(): void {
        const news = this.newsService.getNews(6, this.newsCategory)
            .subscribe(items => this.items = items);
        this.subscriptions.add(news);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private calculateWidth(): void {
        if (!this.newsCarousel) {
            return;
        }

        const clientWidth = this.newsCarousel.nativeElement.clientWidth;
        let total: number = (this.itemsInView) ? this.itemsInView : 4;

        if (clientWidth <= this.tabletSize) {
            total = 2;
        }
        if (clientWidth <= this.mobileSize) {
            total = 1;
        }

        const width = Math.floor(clientWidth / total);

        this.itemWidth = `${width}px`;
        this.cd.detectChanges();
    }
}
